import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FillGame, FillGameLinkBlock } from "../FillGame";
import { FillGameDroppable } from "./FillGameDroppable";

interface IFillGameLinkProps {
  link: FillGameLinkBlock[];
  data: FillGame;
  isValid: boolean;
  mapKey: number;
}

export const FillGameLink: FC<IFillGameLinkProps> = ({
  link,
  data,
  isValid,
  mapKey,
}) => {
  const { t } = useTranslation();

  return (
    <Grid
      item
      xs={12}
      container
      justifyContent="left"
      alignItems="center"
      key={`linkgrid${mapKey}`}
    >
      {link.map((block, ii) => {
        const have = data.droppables?.find(
          (drop) => drop.id === block.id
        )?.have;
        return (
          <Grid
            item
            xs={block.type === "drop" ? false : false}
            key={`fill-block-${block.id}`}
            alignItems="center"
          >
            {(block.type === "drop" && (
              <FillGameDroppable
                id={block.id ?? ""}
                want={block.want ?? []}
                have={have ?? ""}
                disabled={isValid}
              >
                {have && t(`games.${data.id}.${have}`)}
              </FillGameDroppable>
            )) || <Typography>{t(`games.${data.id}.${block.key}`)}</Typography>}
          </Grid>
        );
      })}
    </Grid>
  );
};
